<div class="main-head">
    <div class="head-line">
        <h1>Career</h1>
    </div>
</div>
<div class="container">
    <div class="row">
        <div class="col-md-12">
            <div class="manage-tbl">
                <p class="text-center" *ngIf="!AllCareer.length">No data found</p>
                <table mat-table [dataSource]="AllCareer" class="mat-elevation-z8" width="100%"
                    *ngIf="AllCareer.length">

                    <ng-container matColumnDef="SortId">
                        <th mat-header-cell *matHeaderCellDef> # </th>
                        <td mat-cell *matCellDef="let element"> - </td>
                    </ng-container>
                    <ng-container matColumnDef="Name">
                        <th mat-header-cell *matHeaderCellDef> Name </th>
                        <td mat-cell *matCellDef="let element"> {{element.Name}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Email">
                        <th mat-header-cell *matHeaderCellDef> Email Id </th>
                        <td mat-cell *matCellDef="let element"> {{element.Email}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Phone">
                        <th mat-header-cell *matHeaderCellDef> Contact No. </th>
                        <td mat-cell *matCellDef="let element"> {{element.Phone}} </td>
                    </ng-container>

                    <ng-container matColumnDef="PostFor">
                        <th mat-header-cell *matHeaderCellDef> Post For </th>
                        <td mat-cell *matCellDef="let element"> {{element.PostFor}} </td>
                    </ng-container>

                    <ng-container matColumnDef="CreatedDate">
                        <th mat-header-cell *matHeaderCellDef> Posted On </th>
                        <td mat-cell *matCellDef="let element"> {{element.CreatedDate | date :'dd MMM yyyy @ h:mm:ss a'}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="Operation">
                        <th mat-header-cell *matHeaderCellDef> Operation</th>
                        <td mat-cell *matCellDef="let element" width="50px">
                            <a (click)="viewCareer(element.CareerId)" class="sm" mat-raised-button
                                color="primary">
                                <i class="fa fa-eye" aria-hidden="true"></i>
                            </a>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="EnquiriesColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: EnquiriesColumns;"
                        class="cursorView"></tr>

                </table>
            </div>
        </div>
    </div>
</div>